import { useApiClient } from '@hetivo/hetivo-lib-front-utils';
import type { InspectionStats, InspectionStatsCriteria } from '@hetivo/hetivo-lib-types';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { createInspectionApi, inspectionKeys } from '../api';

/**
 * The three tab counts of the Inspections list (SWOOP-400). The same endpoint and key feed the sidebar badge
 * (`useInspectionsDueCount`), so the Due tab and the badge always agree (SC-003).
 */
export function useInspectionStats(criteria: InspectionStatsCriteria, enabled = true): UseQueryResult<InspectionStats> {
  const client = useApiClient('admin-auth');
  const api = createInspectionApi(client);

  return useQuery({
    enabled,
    gcTime: 5 * 60_000,
    queryFn: () => api.stats(criteria),
    queryKey: inspectionKeys.stats(criteria),
    staleTime: 30_000,
  });
}
